<template>
<div>
  <b-modal
    id="attraction"
    hide-footer
    centered
    v-model="isVisible"
    :size="journey ? 'lg' : 'md'"
    :modal-class="['modal-cover', { 'attraction-modal-journey': journey }]"
    content-class="shadow-lg"
  >
    <JourneyAttractionDetails v-if="journey"/>
    <div v-else :dir="isEnglish ? 'ltr' : 'rtl'" :style="{ textAlign: isEnglish ? 'left' : 'right' }">
    <div v-if="isNewAttractionRate && !isSubdomain" class="star-rating-container">
      <star-rating
        class="star-custom-beautiful"
        :read-only="true"
        :rtl="!isEnglish"
        :increment="0.01"
        :star-size="35"
        :border-width="2"
        :rating="newAttractionRate"
        :glow="5"
        :active-color="'#FFD700'"
        :inactive-color="'#E5E5E5'"
        :border-color="'#FFB500'"
      />
    </div>

    <div>
      <div class="attraction-clear-image">
        <img 
        :src="newAttractionImage"
      />
      </div>
      <b>
        <h3 class="font-weight-medium card-title">{{newAttractionTitle}}</h3>
      </b>
      <p class="usingNewLine" v-html="attractionText">
      </p>
      <br>
      <b-link
        v-if="newAttractionLink"
        :href="newAttractionLink"
        target="_blank"
        class="clikable d-inline-flex align-items-center attraction-button-size primary rounded-pill fs-6"
      >
        <img  
          width="23px"
          height="18px"
          alt="linkAttractionIcon"
          class="ms-2 attraction-button-image"
          :src="linkAtttractionIcon()"
        >
        {{ t('viewPlace') }} 
      </b-link>

      <div v-if="newAttractionVoucherUrl" class="attraction-modal-voucher-row mt-2">
        <b-link
          :href="newAttractionVoucherUrl"
          target="_blank"
          class="clikable d-inline-flex align-items-center attraction-button-size primary rounded-pill fs-6"
        >
          <span class="material-icons ms-2">receipt_long</span>
          {{ t('voucher') }}
        </b-link>
      </div>

      <!-- Video, Audio media section -->
      <div
        v-if="newAttractionVideoUrl || newAttractionAudioUrl"
        class="attraction-modal-media-section mt-3"
      >
        <div v-if="newAttractionVideoUrl" class="attraction-modal-media-item">
          <p class="attraction-modal-media-label mb-1">{{ t('video') }}</p>
          <video
            controls
            preload="none"
            class="attraction-modal-media-video"
            :src="newAttractionVideoUrl"
            poster="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 180'%3E%3Crect fill='%23ddd' width='320' height='180'/%3E%3Cpolygon fill='%23999' points='130,70 130,110 160,90'/%3E%3C/svg%3E"
          >
            {{ t('videoTagNotSupported') }}
          </video>
        </div>
        <div v-if="newAttractionAudioUrl" class="attraction-modal-media-item">
          <p class="attraction-modal-media-label mb-1">{{ t('audio') }}</p>
          <audio
            controls
            class="attraction-modal-media-audio"
            :src="newAttractionAudioUrl"
          >
            {{ t('audioTagNotSupported') }}
          </audio>
        </div>
      </div>

  </div>
  <div v-if="newAttractionOpeningHours" class="centering-with-start">
    <div>
      <h3 class="bold" >
        {{ t('openingHours') }}
      </h3>
      <p v-for="(oneDayOpenHours, index ) in newAttractionOpeningHours"
      :key="index">
          {{oneDayOpenHours}}
      </p>
    </div>
  </div>
    <div 
      class="stretching"
      v-if="isNewAttractionReview && !isSubdomain">
        <h3 class="bold" >
          {{ t('placeReviews') }}
        </h3>
      <div  v-for="(review, index ) in newAttractionReview"
          class="attraction_review"
          :key="index">
        <p>
          {{review.author_name}}

        </p>
        <star-rating
          :v-if=review.rating
          :read-only="true"
          :rtl="!isEnglish"
          :increment="0.01"
          :star-size="15"
          :rating=review.rating
          />
        <p>
          {{review.text}}
        </p>
      </div>
    </div>
    </div>
  </b-modal>
</div>
</template>
<script>

import { mapGetters } from "vuex";
import StarRating from 'vue-star-rating'
import config from '@/common/config';
import { translationMixin } from "@/mixins/translationMixin";
import { designFor } from "@/designs";
import JourneyAttractionDetails from "@/designs/journey/JourneyAttractionDetails";
export default {
props: ["value"],
mixins: [translationMixin],
  name: "AtractionPopUp",
  components: {
    StarRating,
    JourneyAttractionDetails
  },

  computed: {
    ...mapGetters([ 'allRide',
                    'newAttractionTitle',
                    'newAttractionAddress',
                    'newAttractionText',
                    'newAttractionLink',
                    'newAttractionLat',
                    'newAttractionLng',
                    'newAttractionImage',
                    'isNewAttractionImage',
                    'newAttractionpreviewImage',
                    'newAttractionVideoUrl',
                    'newAttractionAudioUrl',
                    'newAttractionVoucherUrl',
                    'isNewAttractionEditMode',
                    'newAttractionOpeningHours',
                    'newAttractionReview',
                    'newAttractionRate',
                    'isNewAttractionRate',
                    'isNewAttractionReview' ]),
    ...mapGetters("theme",  [ "isSubdomain",
                        ]),
    ...mapGetters([ 'rideHeader' ]),

    // On a trip page in the journey design the popup is that design's own
    // (JourneyAttractionDetails); everywhere else it is this one.
    journey() {
      const onTripPage = this.$route && this.$route.path.startsWith('/single_ride_with_map');
      const ride = this.rideHeader && this.rideHeader.ride;
      return !!onTripPage && designFor(ride && ride.presentation_design).id === 'journey';
    },

    attractionText:{
        get () {
          return this.newAttractionText
        },
        set (value) {
          this.$store.commit('setNewAttractionText', value)
        }
      },

    isVisible: {
        set(val) {
            this.$emit("input", val);
        },
        get() {
            return this.value;
        },
        },
    },


methods:{
    linkAtttractionIcon(){
      return config.config.LINK_ATTRACTION_ICON
    },
    getLinkUrl(){
      if ( this.allRide && this.allRide.ride && this.allRide.ride.id ){
        return ( "http://tripplanner.co.il/single_ride_with_map/" + this.allRide.ride.id )
      }
      return "http://tripplanner.co.il/single_ride_with_map/"
    },
    getWhatsappUrl(){
      if ( this.allRide && this.allRide.ride && this.allRide.ride.id ){
        return "https://web.whatsapp.com/send?text=http://tripplanner.co.il/single_ride_with_map/" + this.allRide.ride.id
      }
      return "https://web.whatsapp.com/send?text=http://tripplanner.co.il/single_ride_with_map/"
    },

  },

};
</script>
<style scoped>
.modal.modal-cover .modal-content,
.modal.modal-cover .modal-footer,
.modal.modal-cover .modal-header {
  border: none;
  align-items: stretch;
}

p{
  letter-spacing: 0.045em;
  line-height: 1.4;
  font-size: 1.8rem;


}

.attraction-clear-image img {
  position: relative;
  /* directional padding is set by [dir] rules below */
  width: 20rem;
}

/* RTL (Hebrew) - image on the left */
[dir="rtl"] .attraction-clear-image img {
  float: left;
  padding-right: 3rem;
  padding-left: 0;
}

/* LTR (English) - image on the right (placed after RTL to take precedence when nested) */
[dir="ltr"] .attraction-clear-image img {
  float: right;
  padding-left: 3rem;
  padding-right: 0;
}

 @media (max-width: 734px) {
  .attraction-clear-image img {
    display: none;
  } 
}

.image-container{
  min-height: 10rem;
  width: 100%;
  padding-bottom: 1rem;

}

.modal-header button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  /* height: 1rem; */
  background: white;
  color: black;
}

.star-rating-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem 0;
  padding: 0.5rem;
}

.star-custom-beautiful {
  display: flex;
  align-items: center;
  justify-content: center;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.star-rating-container:hover .star-custom-beautiful {
  transform: scale(1.05);
  transition: all 0.3s ease;
}


.height-50 {
  height: 50px !important;
}
.width-50 {
  width: 50px !important;
}

.image-and-conntent{
  display: grid;
  margin-right: 2rem;
  grid-template-columns: auto 22rem;

}

.attraction_review{
  margin: 1rem 2rem;
  border-bottom: .5px solid;
  /* justify-items: stretch; */

}

/* Attraction modal media section */
.attraction-modal-media-section {
  border-top: 1px solid #f0f0f0;
  padding-top: 1rem;
}

.attraction-modal-media-item {
  margin-bottom: 1rem;
}

.attraction-modal-media-item:last-child {
  margin-bottom: 0;
}

.attraction-modal-media-label {
  font-weight: 600;
  font-size: 1.4rem;
  color: #0D2F29;
}

.attraction-modal-media-video {
  width: 100%;
  max-width: 320px;
  max-height: 240px;
  border-radius: 8px;
  background: #000;
}

.attraction-modal-media-audio {
  width: 100%;
  max-width: 320px;
  height: 40px;
}








</style>


















